import { useQuery } from "@tanstack/react-query";
import { useLocation } from "wouter";
import { apiRequest } from "@/lib/queryClient";
import { entityDetailKey } from "@/lib/queryKeys";
import { UserNotesPanel } from "@/components/notes/UserNotesPanel";

interface BranchDrawerContentProps {
  id: number;
}

/** Anteprima condivisa di una Filiale, usata dai contesti email e CRM. */
export default function BranchDrawerContent({ id }: BranchDrawerContentProps) {
  const [, navigate] = useLocation();
  const { data: branch, isLoading, isError } = useQuery({
    queryKey: entityDetailKey('branches', id),
    queryFn: () => apiRequest(`/api/branches/${id}`),
    enabled: id != null,
  });

  if (isLoading) return <div className="p-5 text-muted-foreground">Caricamento...</div>;
  if (isError || !branch) return <div className="p-5 text-destructive">Errore caricamento filiale</div>;

  const address = [branch.address, branch.city, branch.province, branch.postalCode]
    .filter(Boolean)
    .join(", ");

  return (
    <div className="flex flex-col">
      <div className="p-5 border-b border-border">
        <h2 className="text-lg font-semibold text-foreground">{branch.name || "Filiale senza nome"}</h2>
        <div className="mt-1 text-sm text-muted-foreground">Filiale</div>
      </div>
      {branch.companyName && (
        <div className="p-5 border-b border-border">
          <div className="text-xs uppercase tracking-wide text-muted-foreground mb-1">Azienda madre</div>
          {branch.companyId ? (
            <button type="button" onClick={() => navigate(`/companies/${branch.companyId}`)} className="text-primary hover:underline">
              {branch.companyName}
            </button>
          ) : <span className="text-foreground">{branch.companyName}</span>}
        </div>
      )}
      {address && (
        <div className="p-5 border-b border-border">
          <div className="text-xs uppercase tracking-wide text-muted-foreground mb-1">Sede</div>
          <div className="text-foreground">{address}</div>
        </div>
      )}
      {(branch.email || branch.phone) && (
        <div className="p-5 border-b border-border">
          <div className="text-xs uppercase tracking-wide text-muted-foreground mb-1">Contatti</div>
          <div className="space-y-1 text-foreground">
            {branch.email && <div>{branch.email}</div>}
            {branch.phone && <div>{branch.phone}</div>}
          </div>
        </div>
      )}
      <div className="p-5 border-b border-border">
        <UserNotesPanel entityType="branch" entityId={id} notesUser={branch.notes_user} />
      </div>
      <div className="p-5">
        <button type="button" onClick={() => navigate(`/branches/${id}`)} className="text-sm font-medium text-primary hover:underline">
          Apri scheda completa
        </button>
      </div>
    </div>
  );
}
